import { render } from "./editPhone.vue?vue&type=template&id=1af04c32&scoped=true"
import script from "./editPhone.vue?vue&type=script&lang=js"
export * from "./editPhone.vue?vue&type=script&lang=js"

import "./editPhone.vue?vue&type=style&index=0&id=1af04c32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af04c32"]])

export default __exports__